const instructions = {
  access: 'Give camera access',
  network: 'Be connected to a network',
  point: 'Point the camera to a GEEQUIP QRcode',
};

export default instructions;
